import { Link } from 'react-router-dom';

// Turns "**bold**", "[text](/path)" and "**[text](/path)**" (a bold link)
// inside a string into real elements, so blog content in src/data/blog.js
// can link to a product or contact page without needing a full Markdown
// parser. Internal links (starting with "/") use react-router's Link so
// they don't reload the page; anything else opens in a new tab.
//
// The bold-link pattern is matched before plain "**bold**" so that
// "**[text](url)**" renders as a link, not literal brackets inside a
// <strong>; links are already visually distinct (colour + weight) via CSS,
// so no separate <strong> wrapper is needed around them.
const TOKEN = /(\*\*\[[^\]]+\]\([^)]+\)\*\*|\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;

const renderLink = (key, label, href) =>
  href.startsWith('/') ? (
    <Link key={key} to={href}>{label}</Link>
  ) : (
    <a key={key} href={href} target="_blank" rel="noopener noreferrer">{label}</a>
  );

const RichText = ({ text }) => {
  const parts = text.split(TOKEN).filter(Boolean);
  return parts.map((part, i) => {
    const boldLink = part.match(/^\*\*\[([^\]]+)\]\(([^)]+)\)\*\*$/);
    if (boldLink) {
      const [, label, href] = boldLink;
      return renderLink(i, label, href);
    }
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      return renderLink(i, link[1], link[2]);
    }
    return part;
  });
};

export default RichText;
